import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ShieldOff } from 'lucide-react';
import { can } from '../utils';

// A module that needs a view permission (Permission Matrix). Without it the page explains why instead
// of loading screens whose every request the server would refuse.
export default function PermissionGate({ user, perm, anyOf, module, children }) {
  const navigate = useNavigate();
  if (!user || (anyOf ? can(user, ...anyOf) : can(user, perm))) return children;
  return (
    <div className="fade-in" style={{ display: 'flex', justifyContent: 'center', padding: '60px 16px' }}>
      <div style={{ maxWidth: 460, textAlign: 'center', background: 'var(--bg-card)', border: '2px solid black', borderRadius: 18, padding: '34px 28px' }}>
        <div style={{ width: 56, height: 56, borderRadius: 16, margin: '0 auto 14px', display: 'grid', placeItems: 'center', background: 'rgba(220,38,38,0.1)', color: '#dc2626' }}>
          <ShieldOff size={28} />
        </div>
        <h2 style={{ margin: '0 0 8px', fontSize: 19, fontWeight: 800, color: 'var(--text-primary)' }}>No access to {module}</h2>
        <p style={{ margin: '0 0 20px', fontSize: 13.5, color: 'var(--text-secondary)', lineHeight: 1.55 }}>
          Your roles do not include permission to use {module}. Ask an administrator to grant it in
          User Access Control → Permission Matrix.
        </p>
        <button onClick={() => navigate('/profile')} style={{ background: '#0b318b', color: '#fff', border: 'none', borderRadius: 10, padding: '10px 20px', fontWeight: 700, cursor: 'pointer' }}>
          Go to My Profile
        </button>
      </div>
    </div>
  );
}
